export const FacultyAdvisors = [
    {
        "name": "Prof. AK Mohapatra",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/c_fill,w_250,h_350,g_auto/v1673976988/prof-akm_kuc76n.jpg",
        "title":"FACULTY ADVISOR"
    },
    {
        "name": "Ms Shweta Singhal",
        "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350,g_auto/v1727618713/Shweta-Singhal-3_ddkyjf_xo45z8.jpg",
        "title":"FACULTY ADVISOR"
    }
]

export const Solaris=[
    {
        "name": "Pooja Gera",
        "url": "https://res.cloudinary.com/dp6tqc0bs/image/upload/v1669188337/2_tzl7qa.png",
        "title":"FOUNDER"
    },
    {
        "name": "Nishtha Goyal",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641379/cb0003_ia0jlr.png",
        "title":"FOUNDER"
    },
    {
        "name": "Gaurisha R Shrivastava",
        "url": "https://res.cloudinary.com/dp6tqc0bs/image/upload/v1669188335/1_bqgctd.png",
        "title":"FOUNDER"
    },
    {
        "name": "Abhigya Verma",
        "url": "https://res.cloudinary.com/dp6tqc0bs/image/upload/v1669188337/3_vklccx.png",
        "title":"FOUNDER"
    }
    ,
    {
        "name": "Himani Agarwal",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641389/cb0111_s5rewk.png",
        "title": "SOLARIS (2023-24)"
    },

    {
        "name": "Jahnvi Srivastav",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641367/cb0122_gds90i.png",
        "title": "SOLARIS (2023-24)"
    },

    {
        "name": "Sanskriti Agarwal ",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641361/cb0252_ig9vkn.png",
        "title": "SOLARIS (2023-24)"
    },
    {
        "name": "Ishita Paul ",
        "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350,g_auto/v1739771269/pfp_c4f4zw.jpg",
        "title": "SOLARIS (2024-25)"
    },

    {
        "name": "Saachi Bansal",
        "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350/v1739898685/b9601d19-823b-48ad-8512-11eedee73dc8.png",
        "title": "SOLARIS (2024-25)"
    }
]

export const Solaris2425=[
    { 
        "name": "Bhavya", 
        "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350/v1761888487/Bhavya_dzyflf.jpg", 
        "title": "SOLARIS" 
    },
    { 
        "name": "Jasleen Kaur", 
        "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350/v1761888488/Jasleen_ksyut4.jpg", 
        "title": "SOLARIS" 
    },
    { 
        "name": "Shriya Sandilya", 
        "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350/v1761888962/Shriya_js9lti.jpg", 
        "title": "SOLARIS" 
    }
]

export const Nebula=[
    {
        "name": "Sanskriti Agarwal ",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641361/cb0252_ig9vkn.png",
        "title": "NEBULA (2022-23)"
    },

    {
        "name": "Anushka Aggarwal",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641384/cb0039_pldmku.png",
        "title": "NEBULA (2023-24)"
    },
    {
        "name": "Tanisha Agrawal",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641363/cb0316_waybhx.png",
        "title": "NEBULA (2023-24)"
    },
    {
        "name": "Tanisha Bansal",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641363/cb0318_zsqc1y.png",
        "title": "NEBULA (2023-24)"
    },
    {
        "name": "Tarushi Tyagi",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641364/cb0329_kzd5yp.png",
        "title": "NEBULA (2023-24)"
    },
    {
        "name": "Himanshi Kaushal ",
        "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_crop,w_250,h_350/v1739771556/Screenshot_2025-02-17_112057_sxojgs.png",
        "title": "NEBULA (2024-25)"
    },
    {
        "name": "Ipshita Tandon ",
        "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350/v1739771576/Screenshot_2025-02-17_112125_yvrgwl.png",
        "title": "NEBULA (2024-25)"
    },
    {
        "name": "Trisha Tomy ",
        "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350,g_auto/v1739897265/3c6959ef-acb3-40d0-b540-9efec16b763d.png",
        "title": "NEBULA (2024-25)"
    }
]

export const Nebula2425=[
    { 
        "name": "Himani Gupta", 
        "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350,g_auto/v1761938807/Screenshot_2025-11-01_005625_vsudcu.png", 
        "title": "NEBULA" 
    },
    { 
        "name": "Rose Kakrania", 
        "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350,g_auto/v1761888497/Rose_nuyc3v.jpg", 
        "title": "NEBULA"
    },
    { 
        "name": "Shanvi",
        "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350,g_auto/v1739772222/WhatsApp_Image_2025-01-21_at_17.28.30_1_-_Shanvi_l1eib8.jpg", 
        "title": "NEBULA" 
    },
    {
        "name": "Palak Khanna",
        "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350,g_auto/v1761888487/Palak_a2z7vz.jpg", 
        "title": "NEBULA" 
    }
]

export const Meridians2425 = [ 
    { "name": "Anushka", "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350/v1745986212/IMG_20250401_195640_-_Anushka_cjav4a.jpg", "title": "MERIDIAN" },
    { "name": "Archi Goyal", "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350,g_auto/v1739772225/IMG-20241002-WA0270_4_-_Archi_Goyal_cznsl4.jpg", "title": "MERIDIAN" },
    { "name": "Arni Goyal", "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350,g_auto/v1739772220/Arni_Goyal_-_Arni_Goyal_bzkkwd.jpg", "title": "MERIDIAN" },
    { "name": "Avani Mathur", "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350,g_auto/v1739772223/IMG-20231031-WA0006_-_Avani_Mathur_037_c1kklo.jpg", "title": "MERIDIAN" },
    { "name": "Deepasha", "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350,g_auto/v1739772221/my_photo_-_Deepasha_onf1p1.jpg", "title": "MERIDIAN" },
    { "name": "Ekamjot Kaur", "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350,g_auto/v1739772224/WhatsApp_Image_2025-01-12_at_00.27.27_892bcb44_-_Ekamjot_Kaur_060_p4jy5k.jpg", "title": "MERIDIAN" },
    { "name": "Harshita Agarwal", "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350,g_auto/v1739772226/IMG-20250209-WA0007_-_Harshita_Agarwal_b068qb.jpg", "title": "MERIDIAN" },
    { "name": "Kavya Chaudhari", "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350,g_auto/v1745987230/Kavya_image_-_kavya_chaudhari_z7uzda.jpg", "title": "MERIDIAN" },
    { "name": "Nandini Jain", "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350,g_auto/v1745986211/WhatsApp_Image_2025-02-16_at_20.36.04_8b8aa7eb_-_Nandini_Jain_fafqgh.jpg", "title": "MERIDIAN" },
    { "name": "Nandini Pandey", "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350,g_auto/v1739772219/cb_img_-_Nandini_Pandey_ohjlpl.jpg", "title": "MERIDIAN" },
    { "name": "Poornima Bhatt", "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350,g_auto/v1745986210/IMG_20250206_200153958_2_-_Poornima_Bhatt_scagyd.jpg", "title": "MERIDIAN" },
    { "name": "Pragati", "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350,g_auto/v1739772220/e84f36b2-d9af-41f9-bf29-2b4d6452219d_-_Pragati_hbtypq.jpg", "title": "MERIDIAN" },
    { "name": "Pranjal Jain", "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350,g_auto/v1739772224/IMG_20240619_130419_-_Pranjal_Jain_cet5s7.jpg", "title": "MERIDIAN" },
    { "name": "Preetika Agrawal", "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350,g_auto/v1739772228/image-800x560.jpg_-_Preetika_Agrawal_g91wws.png", "title": "MERIDIAN" },
    { "name": "Priyal Gupta", "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350,g_auto/v1745986222/d5eb9320-2511-4f58-ab0f-3e1e574c6c88_-_Priyal_Gupta_kuywek.jpg", "title": "MERIDIAN" },
    { "name": "Rupali Kardam", "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350,g_auto/v1745986211/profile_-_Rupali_Kardam_lbzm1c.jpg", "title": "MERIDIAN" },
    { "name": "Shweta Surbhi", "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350/v1739772220/potrait_pic_-_Shweta_Surbhi_efyljb.jpg", "title": "MERIDIAN" },
    { "name": "Snigdha Choudhury", "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350,g_auto/v1739772228/Picsart_24-12-02_17-17-04-038_-_Snigdha_Choudhury_aipmkb.jpg", "title": "MERIDIAN" },
    { "name": "Taneesha Nayal", "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350,g_auto/v1745986222/Polish_20240824_225936879_3_-_Taneesha_Nayal_lcd4gh.jpg", "title": "MERIDIAN" },
    { "name": "Yashvi Gupta", "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350,g_auto/v1739772229/IMG_20250212_175632_-_yashvi_gupta_lxhjvo.png", "title": "MERIDIAN" },
    { "name": "Zoya Parveen Ansari", "url": "https://res.cloudinary.com/dv7ppy9su/image/upload/c_fill,w_250,h_350,g_auto/v1739772219/Zoya_-_Zoya_ipxhjx.jpg", "title": "MERIDIAN" }
  ];

export const Retrograde=[
    {
        "name": "Ishita Saxena",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641366/cb0120_hn0i5n.png",
        "title": "RETROGRADE"
    },
    {
        "name": "Mehek Prabhakar",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641374/cb0166_stc9fa.png",
        "title": "RETROGRADE"
    },
    {
        "name": "Riddhi Barodia",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641359/cb0230_aibh9w.png",
        "title": "RETROGRADE"
    },
    {
        "name": "Saloni Gupta",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641360/cb0247_mlsrnl.png",
        "title": "RETROGRADE"
    },
    {
        "name": "Sona Varshney",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669888329/cb0295_q334xj.png",
        "title": "RETROGRADE"
    },
    {
        "name": "Tanisha Agrawal",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641363/cb0316_waybhx.png",
        "title": "RETROGRADE"
    },
    {
        "name": "Tarushi Tyagi",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641364/cb0329_kzd5yp.png",
        "title": "RETROGRADE"
    },
    {
        "name": "Meghna",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641364/cb0353_y0or7h.png",
        "title": "RETROGRADE"
    }
]

export const Quasars=[
    {
        "name": "Aadya Mittal",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641379/cb0005_gwx1h2.png",
        "title": "QUASAR"
    },
    {
        "name": "Aastha pinhatiya",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641382/cb0013_z6epxr.png",
        "title": "QUASAR"
    },
    {
        "name": "Kirti Aggarwal",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641374/cb0145_adzoaz.png",
        "title": "QUASAR"
    },
    {
        "name": "Nishtha Agarwal",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641375/cb0192_nx9r50.png",
        "title": "QUASAR"
    },
    {
        "name": "Saloni Gupta",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641360/cb0247_mlsrnl.png",
        "title": "QUASAR"
    },
    {
        "name": "Shanaya Aggarwal",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641361/cb0264_wvq6mm.png",
        "title": "QUASAR"
    },
    {
        "name": "Meghna",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641364/cb0353_y0or7h.png",
        "title": "QUASAR"
    }
]

export const Meridians=[
    {
        "name": "Aishvi Guleria",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641381/cb0018_mthuha.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Akanksha Jha",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641380/cb0020_hyhtvz.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Akansha Gupta",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641382/cb0021_pzyxbv.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Akshita",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641380/cb0024_ahfss6.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Alka",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669834544/cb0025_pqgplz.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Anamika Pandey",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641381/cb0026_kc1js0.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Ananya Bhardwaj",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641381/cb0028_fq39o5.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Anishka",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669834543/cb0034_jo9600.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Anjali Jha",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641382/cb0035_ypexsy.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Anju",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641382/cb0036_z8tu4i.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Anusha Gupta",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669834544/cb0037_wwxsvg.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Anusha Singh",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641383/cb0038_b003ys.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Anushka Dhoundiyal",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669834544/cb0040_yldfbh.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Anushka Singh ",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641383/cb0044_z4szjl.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Arpita Jain",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641384/cb0049_uzunt5.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Arti",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669834544/cb0051_i5y8z6.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Astha Varshney",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641383/cb0057_pf9l1x.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Bhashi",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641384/cb0063_ptli0c.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Bhoomi Tanwar",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641384/cb0066_yqb6tr.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Charu Rana",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641384/cb0069_mqyu2x.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Deepanita Shah",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641384/cb0075_fg5haq.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Deepanshi Chourasia",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641384/cb0076_r9h0lb.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Deepika Kumari",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641387/cb0077_s3sbou.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Dhairya Lamba",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641385/cb0079_lcu8qo.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Divyansha Arora",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641387/cb0087_mw7dbd.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Drishti Jain",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641385/cb0089_zwfs9h.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Gauri Maheshwari ",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641387/cb0094_yth0tv.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Geetika Gupta",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641387/cb0095_eakgja.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Gunjan Gupta",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641388/cb0097_ynnlml.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Gunjan Yadav",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641388/cb0098_tjhqfu.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Harsheen Kaur Sood ",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641389/cb0101_moszcb.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Harshita Deep",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669834545/cb0104_bx9muk.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Harshita Verma ",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641389/cb0109_xetbl9.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Himanshi Sharma",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669834546/cb0112_gaolka.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Ishita Rakchhit",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641389/cb0119_kghyoz.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Jahnavi Malhotra",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641366/cb0121_qzlfx3.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Jai Shree Jain",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641369/cb0123_e6dgqn.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Kamya Varshney",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641369/cb0128_ai9web.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Karishma Kumari",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641369/cb0129_jnhq0k.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Karishma Jain",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641371/cb0130_k9nbgj.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Kashika Jain",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669834546/cb0131_auf3i4.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Kashish Saini",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641372/cb0132_qzk5v6.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Kavya Sethia",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641373/cb0133_g5rcgw.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Khushi",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641371/cb0134_n54gls.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Khushi Anand",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641374/cb0135_u1dtlx.png",
        "title": "MERIDIAN"
    },
    {
        "name": "",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641372/cb0136_sm6iao.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Khushi Garg",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641372/cb0137_di9rha.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Khushi Rastogi",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669834545/cb0141_k4dkig.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Khushi Sinha",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641373/cb0142_mzouhm.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Khyati Gupta",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669834546/cb0143_telvha.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Kirti",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641372/cb0144_j2u0gp.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Manasvvi Aggarwal",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669834546/cb0154_dtx3v4.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Mansi",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641373/cb0158_crf0hl.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Mridu Pant",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641374/cb0171_ehsjrg.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Muskan Gupta",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641374/cb0172_w7to9r.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Nancy",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669834546/cb0178_xlemc8.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Nancy",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669834547/cb0179_vkvwsh.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Nidhi Bhatt",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641376/cb0188_agusja.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Nikhila K S",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641375/cb0189_sc2csc.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Nikita Garg ",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641375/cb0190_mfv4ft.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Nitya Pasrija",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641376/cb0194_cfdvpe.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Palak Agrawal",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641376/cb0195_wy2ry7.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Palak Malhotra",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669834546/cb0198_sckfhr.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Pari Khaitan",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641377/cb0200_rwurh3.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Payanshi Jain",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641376/cb0203_xthumr.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Plaksha",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641377/cb0204_uj9rph.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Pooja Ramnaney",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641377/cb0207_phahcs.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Prachi Suman",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641379/cb0209_ohgkjn.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Prathna Jain",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641378/cb0213_kc5th1.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Preksha Gupta",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669834550/cb0217_byzlbl.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Prerna Singh",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641378/cb0218_lpffwq.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Priyanka",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641378/cb0222_x1khnr.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Priyasha Jain",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641359/cb0225_ddqtsn.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Punya Garg",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641359/cb0226_fxphyv.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Radhika Jain",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669834547/cb0227_fq0jke.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Rashdeep kaur",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641359/cb0228_vvubsc.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Rishika Kant",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641360/cb0231_ydh5s8.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Riya Agarwal",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641360/cb0233_v24bai.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Sakshi Pandey",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641360/cb0242_cege6j.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Saloni Gupta",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669834548/cb0246_pdwtvl.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Saloni Stuti",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641360/cb0248_oicren.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Samiksha Garg",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669834550/cb0250_lpujgs.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Samiksha Jain",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641361/cb0251_gz6k75.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Sankriti Mishra",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641361/cb0253_jyfiu9.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Saumya",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641361/cb0254_hswbcd.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Saumya Mahajan",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669834549/cb0257_jbxosa.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Shradha Jain",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641361/cb0267_2_aaxv8g.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Shreya Ganjoo",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641362/cb0270_uvi6dt.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Shristi Singh",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641362/cb0276_ryrsk4.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Simran",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669834548/cb0287_szcnea.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Sonam Giri",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641362/cb0296_zgws8j.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Srishti Gupta",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641362/cb0301_zri79i.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Suhani Jain",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641363/cb0306_maqxg6.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Supriya Sharma",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641363/cb0311_zr9opj.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Surbhi Sharma",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641363/cb0312_rnlxoc.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Tanisha Bansal",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641363/cb0318_zsqc1y.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Tanvi Verma",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641363/cb0323_eo3naa.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Teeya Ojha",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641364/cb0330_ejanzb.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Vrinda Aggarwal",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641364/cb0344_adkgxj.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Vrinda Goel",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669834548/cb0345_uuikrv.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Shelly Bhalla",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641365/cb0356_avxujx.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Sukhvinder Kaur",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641364/cb0361_gc18kz.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Upasna",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641365/cb0363_ir6lqd.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Adwita Singh",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669834548/cb0365_rqoj8a.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Ashwani Kumar",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669834548/cb0366_p0w5b9.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Lisha Kumari",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669834550/cb0367_hmramw.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Yamini",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641366/cb0369_wyahnk.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Mridula kumar ",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669834549/cb0371_q7za2d.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Vedika Tyagi",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641365/cb0372_pbp4jr.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Bhavya Jatrana",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641366/cb0373_cjz1kz.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Hiya Singh ",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641366/cb0374_ewqwqm.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Anushka Saini",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641391/cb0377_sto2vb.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Nikita Bhutani",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641390/cb0378_vveguz.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Ria Sindwani",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641391/cb0379_dxte3u.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Pratha Garg",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641392/cb0381_od4h9d.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Priyanjali",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641391/cb0382_jiircf.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Aditi Gahoi",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641390/cb0383_mig5ry.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Anshi Srivastav",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641353/cb0384_babbje.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Diya Singla",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641353/cb0388_baajzj.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Hitakshi",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641353/cb0389_btoyew.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Kirti Gupta",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641354/cb0391_ubtiln.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Leesha",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641354/cb0393_w2y4bo.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Manya",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641354/cb0394_ten2ud.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Mimansa Tripathi",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641354/cb0396_bsrq1x.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Neetika Tandon",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641354/cb0397_s9ohb3.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Pratibha",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641354/cb0398_drclnu.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Riya Kumari",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641355/cb0400_qlugk2.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Shreya Sharma",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641355/cb0401_zr4vt8.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Shruti Bansal",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641356/cb0402_caqi1r.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Swarnim Gill",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641355/cb0404_gndo1h.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Dhyani Patel",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669834550/cb0411_mdrkgi.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Konika",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641356/cb0414_oa4emr.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Nandini Baliyan",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641356/cb0415_z6borj.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Priyanka Loura",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641357/cb0417_tytg9p.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Radhika Bansal",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641356/cb0418_ncecjj.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Sana",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641357/cb0419_x8q7bp.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Sukanya Chopra",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641357/cb0420_yfvxo8.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Sumiran Verma",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641358/cb0421_giwmvl.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Vanshika",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641358/cb0422_j1s7gh.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Kanika Wadhwa",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641358/cb0423_w3ts4y.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Kritika Joshia Pradhan ",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641358/cb0424_izagbn.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Navya Gupta",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669834551/cb0425_ui5t0k.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Shobhita Khatri",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641358/cb0426_dpkjdj.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Mahima",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641358/cb0427_zgxiv3.png",
        "title": "MERIDIAN"
    },
    {
        "name": "Sneha Singh",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641359/cb0428_iddvvr.png",
        "title": "MERIDIAN"
    },
]

export const Martians=[
    {
        "name": "Anushka Aggarwal",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641384/cb0039_pldmku.png",
        "title": "Martian"
    },
    {
        "name": "Drishti Rani",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641387/cb0090_wvetfq.png",
        "title": "Martian"
    },
    {
        "name": "Girisha Sahdev",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641388/cb0096_rr9pww.png",
        "title": "Martian"
    },
    {
        "name": "Himani Agarwal",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641389/cb0111_s5rewk.png",
        "title": "Martian"
    },
    {
        "name": "Jahnvi Srivastav",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641367/cb0122_gds90i.png",
        "title": "Martian"
    },
    {
        "name": "Riddhi Barodia",
        "url": "https://res.cloudinary.com/dcu66bdvp/image/upload/v1669641359/cb0230_aibh9w.png",
        "title": "Martian"
    }
]
